// Animation with wowjs
export const animation = () => {
  import('wowjs')
    .then(WOW => {
      new WOW.WOW().init();
    });
};

// Sticky nav
const stickyNav_ = () => {
  let offset = window.scrollY;
  const stickys = document.querySelectorAll('.main-header');
  for (let i = 0; i < stickys.length; i++) {
    const sticky = stickys[i];
    if (sticky) {
      if (offset > 10) {
        sticky.classList.add('fixed-header');
      } else {
        sticky.classList.remove('fixed-header');
      }
    }
  }
};
export const stickyNav = (stickyClass) =>
  window.addEventListener('scroll', stickyNav_);
